import { SVGProps, Ref, forwardRef } from 'react';

export const GoogleSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m22.87 10.305-.113-.471H12.323v4.332h6.234c-.647 3.015-3.65 4.602-6.104 4.602-1.785 0-3.667-.735-4.912-1.92-1.278-1.217-2.092-3.01-2.092-4.856 0-1.825.835-3.65 2.054-4.85 1.213-1.196 3.052-1.873 4.88-1.873 2.092 0 3.591 1.09 4.152 1.587l3.138-3.063C18.751 3 16.223 1 12.28 1 9.24 1 6.322 2.143 4.192 4.227 2.09 6.279 1 9.247 1 11.997s1.03 5.576 3.068 7.644C6.247 21.847 9.331 23 12.507 23c2.89 0 5.63-1.11 7.581-3.126C22.008 17.89 23 15.144 23 12.267c0-1.211-.124-1.93-.13-1.962"
                fill="currentColor"
            />
        </g>
    </svg>
));
GoogleSolidSize24Glyph.displayName = 'GoogleSolidSize24Glyph';
